import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['typeRadio', 'userField', 'groupField', 'userWrapper', 'groupWrapper']

  connect () {
    this.initializeToggle()
  }

  initializeToggle () {
    // Check if there's already an assigned user or group to determine initial state
    const userSelect = this.getUserSelect()
    const groupSelect = this.getGroupSelect()

    const hasUserAssignment = userSelect && userSelect.value && userSelect.value !== ''
    const hasGroupAssignment = groupSelect && groupSelect.value && groupSelect.value !== ''

    if (hasUserAssignment && !hasGroupAssignment) {
      this.setActiveType('user')
    } else if (hasGroupAssignment && !hasUserAssignment) {
      this.setActiveType('group')
    } else {
      // Default to user assignment if neither is set
      this.setActiveType('group')
    }
  }

  toggle (event) {
    const selectedType = event.target.value
    this.setActiveType(selectedType)
  }

  setActiveType (type) {
    // Update radio button state
    this.typeRadioTargets.forEach(radio => {
      radio.checked = radio.value === type
    })

    if (type === 'user') {
      this.showUserField()
      this.hideGroupField()
      this.clearGroupField()
    } else {
      this.showGroupField()
      this.hideUserField()
      this.clearUserField()
    }
  }

  showUserField () {
    this.userFieldTarget.style.display = 'block'
    this.userFieldTarget.classList.remove('d-none')
  }

  hideUserField () {
    this.userFieldTarget.style.display = 'none'
    this.userFieldTarget.classList.add('d-none')
  }

  showGroupField () {
    this.groupFieldTarget.style.display = 'block'
    this.groupFieldTarget.classList.remove('d-none')
  }

  hideGroupField () {
    this.groupFieldTarget.style.display = 'none'
    this.groupFieldTarget.classList.add('d-none')
  }

  getUserSelect () {
    return this.userFieldTarget.querySelector('select')
  }

  getGroupSelect () {
    return this.groupFieldTarget.querySelector('select')
  }

  clearUserField () {
    const userSelect = this.getUserSelect()
    if (userSelect) {
      // Clear the select value
      userSelect.value = ''

      // Handle Select2 clearing - try multiple approaches
      const $userSelect = $(userSelect)

      if ($userSelect.length && $userSelect.hasClass('select2-hidden-accessible')) {
        // Method 1: Select2 val() method
        $userSelect.val(null).trigger('change')

        // Method 2: Clear selection explicitly
        $userSelect.select2('val', '')

        // Method 3: Destroy and reinitialize if needed
        // $userSelect.select2('destroy').select2()
      }

      // Also clear any hidden input that might store the value
      const hiddenInput = this.userFieldTarget.querySelector('input[type="hidden"]')
      if (hiddenInput) {
        hiddenInput.value = ''
      }
    }
  }

  clearGroupField () {
    const groupSelect = this.getGroupSelect()
    if (groupSelect) {
      // Clear the select value
      groupSelect.value = ''

      // Handle Select2 clearing - try multiple approaches
      const $groupSelect = $(groupSelect)

      if ($groupSelect.length && $groupSelect.hasClass('select2-hidden-accessible')) {
        // Method 1: Select2 val() method
        $groupSelect.val(null).trigger('change')

        // Method 2: Clear selection explicitly
        $groupSelect.select2('val', '')

        // Method 3: Destroy and reinitialize if needed
        // $groupSelect.select2('destroy').select2()
      }

      // Also clear any hidden input that might store the value
      const hiddenInput = this.groupFieldTarget.querySelector('input[type="hidden"]')
      if (hiddenInput) {
        hiddenInput.value = ''
      }
    }
  }
}
